import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">{t('faq.title')}</h2>

        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }} />

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                <div className={`w-5 h-5 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 animate-fade-in">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}